import { Agent } from './agent';

const getToken = () => window.localStorage.getItem('token');

const handleErrors = (err) => {
    const response = err && err.response;
    if (response && response.status === 401) window.localStorage.clear();
    const error = (response && response.body) || { code: -1 };
    throw error;
};

const agent = Agent({ getToken, handleErrors });

const Core = {
    content: () => Promise.resolve(require('../data/content').default),
}

const Common = {
    time: () => agent.get(`/time`),
    country: () => agent.get(`/country`),
    score: (score) => agent.post(`/score`, { score }),
    ranking: (country_id, score) => {
        let endpoint = `/ranking/${country_id}`;
        if (score) endpoint += `/${score}`;
        return agent.get(endpoint)
    },
    
    share: (score) => agent.get(`/share/${score}`),
}

export default {
    Core,
    Common,
};
